import React, { useEffect, useState } from 'react';
import DateFnsAdapter from '@date-io/date-fns';
import { withTranslation } from 'config/i18n';
import { makeStyles } from '@material-ui/core/styles';
import ERTable from 'components/shared/ERTable';
import Dinero from 'dinero.js';
import Link from 'components/shared/Link';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  info: {
    color: theme.palette.info.main,
  },
  italic: {
    fontStyle: 'italic',
  },
  bold: {
    fontWeight: 700,
  },
}));

const EarningsBalanceTable = ({
  t, data, balance, onChange,
}) => {
  const classes = useStyles();

  const dateFns = new DateFnsAdapter();

  const [rows, setRows] = useState([]);

  const [columns] = useState([
    <></>,
    <>{t('fe_earnings_and_payouts_page:payout_withdraw_dialog.table.date')}</>,
    <>{t('fe_earnings_and_payouts_page:payout_withdraw_dialog.table.details')}</>,
    <>{t('fe_earnings_and_payouts_page:payout_withdraw_dialog.table.amount')}</>,
  ]);

  const formatPrice = (value) => `${value.currency_code || ''}${Dinero({
    amount: value.amount || 0,
  }).toFormat('0,0.00')}`;

  const getConfirmationLink = (confirmationNumber, id) => {
    if (!confirmationNumber || !id) return '';
    return (
      <Link
        target="_blank"
        rel="noreferrer"
        color="primary"
        href={`/vehicle_reservations/${id}`}
        className={classes.bold}
      >
        {confirmationNumber}
      </Link>
    );
  };

  useEffect(() => {
    const _rows = [];
    if (data?.payment_distributions) {
      data.payment_distributions.forEach((row) => {
        _rows.push([
          <>
            {
            row.transaction_type && row.transaction_type === 'host_earnings' && row.amount && row.amount.amount && (
              <FormControlLabel
                control={<Checkbox color="primary" />}
                onChange={(e) => {
                  row.checked = e.target.checked; // mark this row as checked
                  onChange(e, row);
                }}
              />
            )
          }
          </>,
          <span>
            {dateFns.isValid(new Date(row.transaction_time))
              ? dateFns.format(new Date(row.transaction_time), 'MMM dd, yyyy')
              : ''}
          </span>,
          <>
            {
              row.transaction_type && (
                <>
                  {
                  row.transaction_type === 'host_earnings' && row.details && (
                    <>
                      {t('fe_earnings_and_payouts_page:transaction_history.table.earnings_from')}
&nbsp;
                      {row.details.vehicle_reservation && getConfirmationLink(row.details.vehicle_reservation.confirmation_number, row.details.vehicle_reservation.id) || ''}
                      <br />
                    </>
                  )
                }
                  {
                  row.transaction_type === 'host_penalty' && row.details && (
                    <>
                      {t('fe_earnings_and_payouts_page:transaction_history.table.penalty_from')}
&nbsp;
                      {row.details.vehicle_reservation && getConfirmationLink(row.details.vehicle_reservation.confirmation_number, row.details.vehicle_reservation.id) || ''}
                      <br />
                    </>
                  )
                }
                </>
              )
            }
          </>,
          <span className={classes.bold}>
            {
            row.amount && (
              <>
                {
                row.transaction_type == 'host_earnings' ? (
                  <span className={classes.info}>
                    {
                      `+ ${formatPrice(row.amount)}`
                  }
                  </span>
                )
                  : (
                    <span>
                      {
                    `- ${formatPrice(row.amount)}`
                  }
                    </span>
                  )
              }
              </>
            )
          }
          </span>,
        ]);
      });
    }
    setRows(_rows);
  }, [data, balance]);

  return (
    <div className={classes.root}>
      {
      data && (
        <ERTable rows={rows} columns={columns} />
      )
    }
    </div>
  );
};

export default withTranslation(['fe_earnings_and_payouts_page'])(EarningsBalanceTable);
